import { useLocal } from '@/i18n/LocalContext'
import { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import './share.scss'
import { useStore } from '@/store'
import CommonModal from '../CommonModal/CommonModal'
import Swiper, { Navigation } from 'swiper'
import { Swiper as SwiperRc, SwiperSlide } from 'swiper/react'
import 'swiper/scss'
import 'swiper/css/navigation'
import { QRCodeCanvas } from 'qrcode.react'
import html2canvas from 'html2canvas'
import { taskShare, syncData } from '@/request'
import bg from '@/assets/role/bg.txt'
import logo from '@/assets/role/logo.txt'
import { toast } from '@/utils'
import { isNative, NativeRequest } from 'onemt-sdk-native'
import { shareReport } from '@/report'

export default function Share() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const [getting, setGetting] = useState(true)
  const [list, setList] = useState([
    {
      img: '',
      id: 1,
    },
    {
      img: '',
      id: 2,
    },
    {
      img: '',
      id: 3,
    },
    {
      img: '',
      id: 4,
    },
    {
      img: '',
      id: 5,
    },
    {
      img: '',
      id: 6,
    },
    {
      img: '',
      id: 7,
    },
    {
      img: '',
      id: 8,
    },
    {
      img: '',
      id: 9,
    },
  ])
  const [activeIndex, setActiveIndex] = useState(0)
  const playerId = state.login.userInfo.playerId
  let shareUrl =
    process.env.ENV === 'production'
      ? 'https://h5share.onemtshare.com/kow/return'
      : 'https://testh5share.onemtshare.com/kow/return'
  const currentUrl = useMemo(
    () =>
      `${shareUrl}/${
        window.location.search
      }&isSinglePic=1&invitationCode=${playerId}&id=${activeIndex + 1}`,
    [playerId, activeIndex]
  )
  const download = () => {
    html2canvas(document.querySelector('.swiper-slide-active .banner-item'), {
      scale: 2,
    }).then((canvas) => {
      const a = document.createElement('a')
      a.href = canvas.toDataURL('image/png')
      a.download = `share_${+new Date()}.png`
      if (isNative()) {
        NativeRequest('saveImage', {
          uri: canvas.toDataURL('image/png'),
        }).then(() => {
          _toast()
        })
      } else {
        a.click()
        // _toast()
      }
    })

    function _toast() {
      toast($t('保存成功'), true)
      /* setTimeout(() => {
        let el = document.querySelector('.toast').cloneNode(true)
        document.querySelector('#share-modal').appendChild(el)
        setTimeout(() => {
          document.querySelector('#share-modal').removeChild(el)
        }, 2000)
      }, 1000) */
    }
  }
  const shareBtn = useCallback(
    async (type: number) => {
      await taskShare(playerId)
      // 同步玩家数据
      syncData(playerId).then((newData) => {
        dispatch({
          type: 'syncData',
          data: {
            friends: newData.list,
            tasks: newData.tasks,
          },
        })
      })

      shareReport(type === 1 ? 'facebook' : 'twitter')
      const title = $t('社媒分享标题')
      const content = $t('社媒分享描述')
      if (isNative()) {
        NativeRequest('share', {
          title,
          content,
          type,
          url: currentUrl,
          imageUrl: `https://sdkstatic.onemt.co/gamestatic/100010017/sharebanner/return/${
            activeIndex + 1
          }_banner.jpg`,
        })
      } else {
        if (type === 1) {
          window.location.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            currentUrl
          )}`
        }
        if (type === 2) {
          window.location.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
            currentUrl
          )}`
        }
      }
    },
    [activeIndex, playerId, currentUrl]
  )
  const handleOnSlideChange = (swiperIns: Swiper) => {
    if(document.querySelector('.swiper-slide-active .banner-item')){
      let className = document.querySelector('.swiper-slide-active .banner-item').className
      let index = className.match(/item-(\d+)/)
      let current = +index[1] - 1
      console.log(current)
      setActiveIndex(current)
    }
  }

  const gotData = useRef(false)
  useEffect(() => {
    if (gotData.current) return

    gotData.current = true

    Promise.all([
      import(
        /* webpackChunkName: "role-1" */
        /* webpackPrefetch: true */
        '../../assets/role/1.txt'
      ),
      import(
        /* webpackChunkName: "role-2" */
        /* webpackPrefetch: true */
        '../../assets/role/2.txt'
      ),
      import(
        /* webpackChunkName: "role-3" */
        /* webpackPrefetch: true */
        '../../assets/role/3.txt'
      ),
      import(
        /* webpackChunkName: "role-4" */
        /* webpackPrefetch: true */
        '../../assets/role/4.txt'
      ),
      import(
        /* webpackChunkName: "role-5" */
        /* webpackPrefetch: true */
        '../../assets/role/5.txt'
      ),
      import(
        /* webpackChunkName: "role-6" */
        /* webpackPrefetch: true */
        '../../assets/role/6.txt'
      ),
      import(
        /* webpackChunkName: "role-7" */
        /* webpackPrefetch: true */
        '../../assets/role/7.txt'
      ),
      import(
        /* webpackChunkName: "role-8" */
        /* webpackPrefetch: true */
        '../../assets/role/8.txt'
      ),
      import(
        /* webpackChunkName: "role-9" */
        /* webpackPrefetch: true */
        '../../assets/role/9.txt'
      ),
    ])
      .then((arr) => {
        setList((oldList: typeof list) =>
          oldList.map((item, i) => {
            const img = arr[i] ? arr[i].default : ''
            item.img = img
            return item
          })
        )
      })
      .finally(() => setGetting(false))
  }, [])

  return (
    <CommonModal
      open={state.modalData.shareOpen}
      title={''}
      type="share"
      length="long"
    >
      {[
        <div key="1" className="common-share-content">
          <div className="banner-info">
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
            <div className="banner-list">
              <SwiperRc
                modules={[Navigation]}
                loop={true}
                lazy={true}
                spaceBetween={20}
                onSlideChangeTransitionEnd={handleOnSlideChange}
                navigation={{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }}
              >
                {list.map((item, i) => (
                  <SwiperSlide key={i}>
                    <div className={`banner-item item-${item.id}`}>
                      <img
                        className="bg-img"
                        loading="lazy"
                        src={item.img}
                        alt=""
                      />
                      <div
                        className="code-info"
                        style={{ backgroundImage: `url(${bg})` }}
                      >
                        <div className="banner-title">
                          {$t('邀请领主回归，获得超值奖励！')}
                        </div>
                        <div className="banner-qrcode">
                          <QRCodeCanvas level="H" value={currentUrl} />
                        </div>
                        {/* <div
                          className="banner-logo"
                          style={{ backgroundImage: `url(${logo})` }}
                        ></div> */}
                        <img src={logo} alt=" " className="banner-logo" />
                        <div className="banner-code-info">
                          <div className="text">{$t('邀请码')}</div>
                          <div className="code">{playerId}</div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </SwiperRc>
            </div>
          </div>
          {getting ? (
            <div className="share-loader">
              <div className="__onemt__loader-box">
                <div className="__onemt__loader"></div>
              </div>
            </div>
          ) : null}
        </div>,
        [
          <div key="21" className="icons">
            <div
              className="icon fb"
              onClick={() => {
                shareBtn(1)
              }}
            ></div>
            <div
              className="icon tt"
              onClick={() => {
                shareBtn(2)
              }}
            ></div>
            {!window.inSDK ? (
              <div className="icon download" onClick={download}></div>
            ) : null}
            {/* <div className="icon download" onClick={download}></div> */}
          </div>,
        ],
      ]}
    </CommonModal>
  )
}
